import routes from '../_helpers/urlPaths';
import apiStatus from '../_helpers/apiStatus';
import http from 'http';
import https from 'https';
import dialogUtil from '../_helpers/dialogUtil';

class NetworkService {
    constructor(SpinnerService, $rootScope, $state) {
        'ngInject';

        this.$state = $state;
        this.$scope = $rootScope;
        this.spinnerService = SpinnerService;
    }

    /**
     * getOptions: Create options header for http request
     * @param {String} httpRequestType method in http header
     * @param {String} apiUrl api url path
     */

    getOptions(httpRequestType, apiUrl) {

        return {
          withCredentials: true,
          host: routes.HOST,
          port: routes.PORT,
          path: routes.PATH + apiUrl,
          method: httpRequestType,
          headers: {
            'Content-Type': 'application/json',
          },
        };
    }

    makeHTTPRequest(options, data, onResult) {
        this.spinnerService.showSpinner();
        const port = options.port === 443 ? https : http;
        const req = port.request(options, async (res) => {
          let output = '';
          res.setEncoding('utf8');
          res.on('data', function (chunk) {
            output += chunk;
          });
          res.on('end', () => {
            if (res.statusCode === 200) {
              if (res.headers["content-type"] === "application/json") {
                const obj = JSON.parse(output);
                if (obj.apiStatus === apiStatus.INVALID_SESSION) {
                  this.$state.go("auth.login");
                } else if (obj.apiStatus === apiStatus.UNAUTHORIZED) {
                  this.$state.go("main.home")
                } else if (obj.apiStatus === apiStatus.ALREADY_EXISTS) {
                  dialogUtil.showErrorMessage("Entry already exists. Please try again.")
                } else {
                  onResult(obj);
                }
              } else {
                // Download file
                this.downloadFile(res, output);
              }

            } else {
              dialogUtil.showErrorMessage("Call to server failed with " + res.statusCode)
            }
            this.spinnerService.hideSpinner();
          });
        });

        if (data !== null) {
          req.write(JSON.stringify(data));
        }

        const parent = this;
        req.on('error', function (err) {
          console.log(`error: ${  err.message}`);
          dialogUtil.showErrorMessage("Call to server failed.")
          parent.spinnerService.hideSpinner();
        });

        req.end();
    }

    /**
     * execute: Execute any http request
     * @param {string} httpRequestType method in http header
     * @param {string} apiUrl api url path
     * @param {Object} data data to be posted
     * @param callback callback function to handle response
     */
    execute (httpRequestType, apiUrl, data, callback) {
        const options = this.getOptions(httpRequestType, apiUrl);
        return this.makeHTTPRequest(options, data, callback);
    }

    downloadFile(response, data) {
      let octetStreamMime = 'application/octet-stream';

      //get the headers' content disposition
      // let cd = response.headers["content-disposition"];
      //
      // //get the file name with regex
      // let regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      // let match = regex.exec(cd);

      //is there a fiel name?
      let fileName = "myDefaultFileName.pdf";

      //replace leading and trailing slashes that C# added to your file name
      fileName = fileName.replace(/\"/g, "");

      //determine the content type from the header or default to octect stream
      let contentType = response.headers["content-type"] || octetStreamMime;

      //finally, download it
      try {
        let blob = new Blob([data], {type: contentType});

          //downloading the file depends on the browser
          //IE handles it differently than chrome/webkit
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let objectUrl = URL.createObjectURL(blob);
              window.open(objectUrl);
          }
      } catch (exc) {
          console.log(exc);
      }
    }
}

export default NetworkService;



// WEBPACK FOOTER //
// ./client/app/_services/network.service.js